import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('rp_user') || 'null'); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const returnUrl = new URLSearchParams(window.location.search).get('r');
    if (returnUrl) localStorage.setItem('rp_returnUrl', returnUrl);
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post('/api/auth/login', { email, password });
      const flat = { ...data.user, resellerName: data.reseller?.name, resellerLogoDataUrl: data.reseller?.logoDataUrl };
      localStorage.setItem('rp_token', data.token);
      localStorage.setItem('rp_user', JSON.stringify(flat));
      localStorage.setItem('rp_reseller', JSON.stringify(data.reseller));
      setUser(flat);
      return flat;
    } finally { setLoading(false); }
  };

  const logout = () => {
    const returnUrl = localStorage.getItem('rp_returnUrl') || 'https://main-leano-platform-test.azurestaticapps.net';
    localStorage.removeItem('rp_token');
    localStorage.removeItem('rp_user');
    setUser(null);
    window.location.assign(returnUrl);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get('/api/auth/me');
      localStorage.setItem('rp_user', JSON.stringify(data));
      setUser(data);
    } catch {}
  };

  useEffect(() => { if (localStorage.getItem('rp_token') && !user) refresh(); }, []); // eslint-disable-line

  const has = (perm) => !!user; // backend enforces; admin-only UI checks use isAdmin
  const isAdmin = !!user && user.roles?.includes('ResellerAdmin');

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh, has, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
